<app-dialog-header titleTranslateKey="scheduler.setup.team-chooser.title" (closeClicked)="onClose()">
</app-dialog-header>

<mat-dialog-content class="dialog-content">
  <mat-selection-list #teamSelection [(ngModel)]="selectedOptions" [compareWith]="compareFunction">
    @for (team of teams; track team) {
    <mat-list-option [value]="team">
      {{ team.name }}
    </mat-list-option>
    }
  </mat-selection-list>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-flat-button color="primary" (click)="save()">
    {{ 'scheduler.general.save' | translate }}
  </button>
</mat-dialog-actions>